export { BvlAutocompleteComponent as BvlAutocomplete } from './autocomplete.component';
export { BvlAutocompleteModule } from './autocomplete.module';
